import script from "./ui-list-view-item.vue?vue&type=script&lang=ts&setup=true"
export * from "./ui-list-view-item.vue?vue&type=script&lang=ts&setup=true"

import "./ui-list-view-item.vue?vue&type=style&index=0&id=d41f67d2&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d41f67d2"]])

export default __exports__